import Flickity from 'flickity';
import './plugins/gridzy.min.js';
import ModuloBox from './plugins/modulobox.js';
import AOS from 'aos';
import Mixitup from 'mixitup';
import Axios from 'axios';
import Bootstrap from 'bootstrap';

import './vue-components/SearchForm/app.js';

if(document.querySelector('.filter-container')) {
    let containerEl = document.querySelector('.filter-container');
    let mixer       = Mixitup(containerEl, {
        selectors: {
            target:  '.filter-item',
            control: '.btn-filter'
        },
        animation: {
            duration: 300,
            easing:   'cubic-bezier(0.645, 0.045, 0.355, 1)'
        },
        load:      {
            filter: document.querySelector('.control-active') !== null ? document.querySelector('.control-active').dataset.filter : 'all'
        }
    });
}

if(document.querySelector('.smooth-scroll')) {
    document.querySelectorAll('.smooth-scroll').forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            let target = document.querySelector(el.getAttribute('href'));
            const y    = target.getBoundingClientRect().top + window.scrollY - document.querySelector('nav').offsetHeight;

            window.scrollTo({
                top:      y,
                behavior: 'smooth'
            })
        });
    })
}

if(window.location.hash) {
    let target = document.querySelector(window.location.hash);
    if(target) {
        const y = target.getBoundingClientRect().top - document.querySelector('nav').offsetHeight;

        setTimeout(() => {
            window.scrollTo({
                top:      y,
                behavior: 'smooth'
            });
        }, 300);
    }
}

// Page body alterations
if(document.querySelector('.page-body')) {
    document.querySelectorAll('.page-body').forEach(item => {
        item.querySelectorAll('img').forEach(image => {
            image.classList.add('img-fluid');
            image.classList.add('cursor-pointer');
        });

        item.querySelectorAll('table').forEach(table => {
            table.classList.add('table');
            table.border = 0;

            if(table.querySelectorAll('tr').length > 1) {
                table.classList.add('table-striped', 'table-hover');
            }

            if(!table.parentNode.classList.contains('table-responsive')) {
                let wrapper       = document.createElement('div');
                wrapper.className = 'table-responsive';

                table.parentNode.insertBefore(wrapper, table);
                wrapper.appendChild(table);
            }
        });

        item.querySelectorAll('iframe').forEach(iframe => {
            if(iframe.src.match(/youtube|youtu/)) {
                iframe.classList.add('embed-responsive-item');
                if(!iframe.parentNode.classList.contains('embed-responsive-16by9')) {
                    let wrapper       = document.createElement('div');
                    wrapper.className = 'embed-responsive embed-responsive-16by9';

                    iframe.parentNode.insertBefore(wrapper, iframe);
                    wrapper.appendChild(iframe);
                }
            }
        });
    });
}

if(document.querySelector('.precursor-modal')) {
    document.querySelectorAll('.precursor-modal').forEach(element => {
        element.addEventListener('click', event => {
            event.preventDefault();

            const url = '/api/' + (event.currentTarget.dataset.api ?? 'precursors') + '/'

            Axios.get(url + event.currentTarget.dataset.id).then((response) => {
                let modal = document.getElementById('precursorModal');
                let html  = '';
                if(response.data.data.youtube.hasVideo) {
                    html += '<div class="embed-container embed-responsive embed-responsive-16by9">\n' +
                        '        <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/' + response.data.data.youtube.id + '?rel=0" frameborder="0" allowfullscreen></iframe>\n' +
                        '    </div>';
                }
                html += '<div class="p-5">'
                if(response.data.data.title) {
                    html += '<h2>' + response.data.data.title + '</h2>';
                }
                if(response.data.data.body !== null) {
                    html += '<div class="mt-3">' + response.data.data.body + '</div>';
                }
                html += '</div>';

                modal.querySelector('.content').innerHTML = html;
                $('#precursorModal').modal();
            });
        });
    });
}

if(document.getElementById('contact-form')) {
    if(document.querySelector('.diet-group') && document.querySelector('[name="plenair_program"]')) {
        document.querySelector('[name="plenair_program"]').addEventListener('change', (e) => {
            document.querySelector('.diet-group').style.display = e.currentTarget.checked ? 'block' : 'none';
        });

        document.querySelector('.diet-group').style.display = document.querySelector('[name="plenair_program"]').checked ? 'block' : 'none';
    }

    let contactForm = document.getElementById('contact-form');
    contactForm.addEventListener('submit', function(event) {
        event.preventDefault();

        let formData = new FormData(this);
        formData.append('g-recaptcha-response', grecaptcha.getResponse());
        let validationAlert = document.getElementById('contact-form-validation');

        const button          = event.currentTarget.querySelector('button[type="submit"]');
        let currentButtonText = button.innerText;
        button.innerHTML      = '<i class="fas fa-circle-notch fa-spin"></i>';
        button.disabled       = true;

        validationAlert.classList.add('hidden');
        validationAlert.classList.remove('alert-danger');
        Axios.post(contactForm.action, formData).then(response => {
            if(response.data.success) {
                validationAlert.innerHTML = response.data.message;
                validationAlert.classList.add('alert-success');
                validationAlert.classList.remove('hidden');

                contactForm.innerHTML = '';
            } else {
                button.innerHTML = currentButtonText;
                button.disabled  = false;
            }

            let y = contactForm.getBoundingClientRect().top + window.pageYOffset + (-250);

            window.scrollTo({top: y, behavior: 'smooth'});
        }).catch(exception => {
            grecaptcha.reset();
            if(exception.response.data.errors) {
                for(let error in exception.response.data.errors) {
                    let el = document.querySelector('[name="' + error + '"]');
                    el.classList.add('is-invalid');
                    if(el.parentNode.querySelector('.d-none') !== null) {
                        el.parentNode.querySelector('.d-none').classList.remove('d-none');
                    }
                }
            }

            button.innerHTML = currentButtonText;
            button.disabled  = false;

            let y = contactForm.getBoundingClientRect().top + window.pageYOffset + (-250);

            window.scrollTo({top: y, behavior: 'smooth'});
        });
    });
}

//3D EFFECT
$(document).mousemove(function(event) {
    $(".dots-move-1").each(function(index, element) {
        let xPos = (event.clientX / $(window).width()) - 1.1,
            yPos = (event.clientY / $(window).height()) - 1.1;
        TweenLite.to(element, 1, {
            rotationY: xPos * 20,
            rotationX: yPos * 20,
            ease:      Power1.easeOut,
        });
    })
    $(".dots-move-2").each(function(index, element) {
        let xPos = (event.clientX / $(window).width()) - 1,
            yPos = (event.clientY / $(window).height()) - 1;
        TweenLite.to(element, 1, {
            rotationY: xPos * 20,
            rotationX: yPos * 20,
            ease:      Power1.easeOut,
        });
    })
    $(".dots-move-3").each(function(index, element) {
        var xPos = (event.clientX / $(window).width()) - 0.2,
            yPos = (event.clientY / $(window).height()) - 0.2;
        TweenLite.to(element, 1, {
            rotationY: xPos * 20,
            rotationX: yPos * 20,
            ease:      Power1.easeOut,
        });
    })
});

// Initialize Animate On Scroll
AOS.init();

// BenedenBoven cookiescript
new CookieNotification();

(function($) {
    "use strict"; // Start of use strict

    // Append .background-image-holder <img>'s as CSS backgrounds
    $('.background-image-holder').each(function() {
        var imgSrc = $(this).children('img').attr('src');
        $(this).css('background', 'url("' + imgSrc + '")');
        $(this).children('img').hide();
        $(this).css('background-position', 'initial');
    });

    // Calc .upcoming events div height
    $('.row').each(function() {
        var divHeight = $(this).find('.app-screenshot').height();
        $(this).find('.app-screenshot-description').css('height', divHeight + 'px');
    });

    // MAP
    $('.map-holder').click(function() {
        $(this).addClass('interact');
    });

    if($('.map-holder').length) {
        $(window).scroll(function() {
            if($('.map-holder.interact').length) {
                $('.map-holder.interact').removeClass('interact');
            }
        });
    }

    // YouTube video in Modal
    $(".video-modal").click(function() {
        var theModal     = $(this).data("target"),
            videoSRC     = $(this).attr("data-video"),
            videoSRCauto = videoSRC + "?modestbranding=1&rel=0&controls=0&showinfo=0&html5=1&autoplay=1";
        $(theModal + ' iframe').attr('src', videoSRCauto);
        $(theModal).on('hidden.bs.modal', function() {
            $(theModal + ' iframe').attr('src', videoSRC);
        });
    });

    // Smooth scrolling using jQuery easing
    $('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function() {
        if(location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target     = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if(target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top - 150
                }, 1000, "easeInOutExpo");
                return false;
            }
        }
    });

    // Init Flickity
    document.querySelectorAll('.carousel-home').forEach((elem) => {
        var flkty = new Flickity(elem, {
            percentPosition: false,
            prevNextButtons: true,
            freeScroll:      true,
            contain:         true,
            wrapAround:      false,
            groupCells:      true,
            pageDots:        true,
            autoPlay:        false
        });
    });

    document.querySelectorAll('.carousel-teammembers').forEach((elem) => {
        var flkty = new Flickity(elem, {
            percentPosition: false,
            prevNextButtons: true,
            freeScroll:      true,
            contain:         true,
            wrapAround:      false,
            groupCells:      true,
            pageDots:        true,
            autoPlay:        false
        });
    });

    // Gridzy
    $('.gridzy').gridzy({
        spaceBetween:  20,
        desiredHeight: 400
    });

    // Modulobox
    var modulobox = new ModuloBox({
        mediaSelector:      '.gallery figure > a, .hidden-gallery div, .page-body :not(a) > img',
        loop:               3,
        history:            true,
        controls:           ['zoom', 'play', 'fullScreen', 'download', 'share', 'close'],
        shareButtons:       ['facebook', 'googleplus', 'twitter', 'pinterest', 'linkedin', 'reddit', 'stumbleupon', 'tumblr', 'blogger', 'buffer', 'digg', 'evernote'],
        videoMaxWidth:      1440,
        minZoom:            1,
        zoomTo:             1.8,
        mouseWheel:         false,
        contextMenu:        false,
        scrollToZoom:       true,
        captionSmallDevice: false,
        thumbnails:         true,
        thumbnailsNav:      'centered',
        thumbnailSizes:     {
            1920: {
                width:  110,
                height: 80,
                gutter: 10
            },
            1280: {
                width:  90,
                height: 65,
                gutter: 10
            },
            680:  {
                width:  0,
                height: 0,
                gutter: 0
            }
        }
    });

    modulobox.on('beforeOpen.modulobox', function(gallery, index) {
        if(window.cubeRAF) {
            cancelAnimationFrame(window.cubeRAF);
            window.cubeRAF = false;
        }
    });

    modulobox.on('afterClose.modulobox', function(gallery, index) {
        if(typeof Event === 'function' && !window.cubeRAF) {
            window.dispatchEvent(new Event('scroll'));
        }
    });

    modulobox.init();

    // Collapse Navbar
    var navbarCollapse = function() {
        if($("#scroll-indicator").offset().top > 1) {
            $("#mainNav").addClass("navbar-shrink");
            if($('.btn-navigation-label').length > 0) {
                $('.btn-navigation-label').css({
                    top: '80px'
                });
            }
        } else {
            $("#mainNav").removeClass("navbar-shrink");

            if($('.btn-navigation-label').length > 0) {
                $('.btn-navigation-label').removeAttr('style');
            }
        }
    };

    // Collapse now if page is not at top
    navbarCollapse();
    // Collapse the navbar when page is scrolled
    $(window).scroll(navbarCollapse);

})($); // End of use strict
